/**
 * @author Petr Mikušek <petr.mikusek@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @template {string} TName
 * @template {Error} [E = Error]
 * @typedef {E & { name: TName; }} ErrorWithName
 */

// TODO:
// - kontrola neprázdného name
// - volitelné property
/**
 * Vytvoří Error s danou message a nastaví custom name.
 * @template {string} TName
 * @param {TName} name
 * @param {string} [message]
 * @param {ErrorOptions} [options]
 * @returns {ErrorWithName<TName>}
 */
export function errorWithName(name, message, options) {
  const error = /** @type {ErrorWithName<TName>} */ (
    new Error(message, options)
  );
  error.name = name;
  return error;
}
